import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {EditClientAdAccountForm} from "./EditClientAdAccountForm";

export class EditClientAdAccountModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulEdited = this.afterSuccessfulEdited.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulEdited(updatedClientAdAccountId) {
        this.toggle();
        this.props.afterSuccessfulEdited(updatedClientAdAccountId);
    }

    render() {
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
                <EditClientAdAccountForm afterSuccessfulEdited={this.afterSuccessfulEdited}
                                        clientId={this.props.clientId}
                                        clientName={this.props.clientName}
                                        clientAdAccount={this.props.clientAdAccount}
                />
            </Modal>
        );
    }
}
